<template>
  <div>
    <DashboardBlock :title="title" class="dashboard-block_achievements">
      <template slot="content">
        <Preloader v-if="isLoading" type="small" />
        <div
          v-if="!isLoading && achievements.length > 0"
          class="content__achievements"
        >
          <AchievementPreview
            v-for="achievement in achievements"
            :key="achievement.id"
            :data="achievement"
            with-popover
          />
        </div>
        <div
          v-if="!isLoading && achievements.length === 0"
          class="content__achievements_empty"
        >
          <span>У вас пока что нет достижений</span>
        </div>
      </template>
    </DashboardBlock>
  </div>
</template>

<script>
import DashboardBlock from '@/_shared/components/ui/DashboardBlock';
import Preloader from '@/_shared/components/ui/Preloader';
import AchievementPreview from '@/user/features/achievements/AchievementPreview';
import { achievementsService } from '@/user/api-services';
export default {
  components: {
    DashboardBlock,
    Preloader,
    AchievementPreview,
  },
  props: {
    onlyLastItems: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
      achievements: [],
    };
  },
  async created() {
    await achievementsService
      .getForUser(this.onlyLastItems)
      .then(({ data }) => {
        this.achievements = data.records;
        this.isLoading = false;
      });
  },
  computed: {
    title() {
      let results = null;
      if (this.onlyLastItems) {
        results = 'Последние достижения';
      }
      return results;
    },
  },
};
</script>

<style scoped>
.dashboard-block_achievements {
  --container-height: 200px;
}
.dashboard-block_achievements .preloader__wrapper_small,
.content__achievements_empty {
  height: var(--container-height);
}
.content__achievements_empty {
  min-height: 100%;
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
}
.content__achievements {
  min-height: var(--container-height);
  display: grid;
  grid-template-columns: repeat(5, auto);
  row-gap: 1em;
  column-gap: 1em;
  padding-top: 1em;
}
@media (max-width: 1439px) {
  .content__achievements {
    grid-template-columns: repeat(4, auto);
  }
}
@media (max-width: 1439px) {
  .content__achievements {
    grid-template-columns: repeat(3, auto);
  }
}
@media (max-width: 991px) {
  .content__achievements {
    grid-template-columns: repeat(2, auto);
  }
}
@media (max-width: 419px) {
  .content__achievements {
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/user/components/personal-area/AchievementsBlock.vue